import { URLS } from 'config';
import type { FunctionComponent } from 'react';
import { Redirect } from 'react-router-dom';

const MarketingPackage: FunctionComponent = function () {
  return <Redirect to={URLS.home} />;
};

export default MarketingPackage;
